module.exports = __webpack_public_path__ + "static/media/idiosPage.9f5c7ce0.png";